import ConfirmationModal from 'components/ui/modals/confirmation/ConfirmationModal'
import { useTranslationRankmi } from 'helpers/translations.helper'

interface ConfirmationEditQuestionProps {
  show: boolean
  onClose: () => void
  onAccept: () => void
}

export const ConfirmationEditQuestion = ({
  show,
  onClose,
  onAccept,
}: ConfirmationEditQuestionProps) => {
  const t = useTranslationRankmi({
    prefix: 'administration.blocks.type.evaluation.modals.modifyingQuestion',
  })
  return (
    <ConfirmationModal
      show={show}
      title={t('title')}
      text={t('text')}
      acceptButtonText={t('buttons.accept')}
      onAccept={onAccept}
      onClose={onClose}
    />
  )
}
